import React from 'react';
import $ from "jquery";

export default class ConfirmDialog extends React.Component
{
    constructor(props) {
        super(props);
        this.state = {
            url: ''
        }

        this.execute = this.execute.bind(this);
    }

    execute() {
        const props = this.props;
        //console.log("execute", '#' + props.elementId);
        $('#' + props.elementId).modal('hide');
    }

    setUrl(url) {
        this.setState({
            url: url
        });
    }

    render() {
        const props = this.props;
        const {url} = this.state;

        return (
            <div className="ConfirmDialog">
                <div className="modal fade" tabIndex="-1" role="dialog" id={props.elementId}>
                    <div className="modal-dialog modal-sm" role="document">
                       <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="modal-title">Confirmação</h2>
                            </div>
                            <div className="modal-body">
                                Deseja realmente emitir o arquivo de retorno?
                            </div>
                            <div className="modal-footer">
                                  <button className="btn btn-light border" data-dismiss="modal">
                                    Cancelar
                                  </button>

                                  <a className="btn btn-primary" onClick={this.execute} href={url}>
                                    Emitir
                                  </a>
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}